import { createTheme, alpha } from "@mui/material/styles";

const brandPrimary = "#6f49c9";
const brandHover = "#5b36b0";
const sidebarBg = "#5c3db8";
const contentBg = "#f8f7fc";

export const appTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: brandPrimary,
      light: alpha(brandPrimary, 0.12),
      dark: brandHover
    },
    background: {
      default: contentBg,
      paper: "#ffffff"
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#eeeeee",
      300: "#e0e0e0",
      400: "#bdbdbd",
      500: "#9e9e9e",
      600: "#757575",
      700: "#616161",
      800: "#424242",
      900: "#212121"
    }
  },
  shape: {
    borderRadius: 12
  },
  typography: {
    fontFamily: '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif',
    h4: { fontWeight: 700, letterSpacing: "-0.02em" },
    h5: { fontWeight: 600, letterSpacing: "-0.01em" },
    h6: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 }
  },
  shadows: [
    "none",
    "0 1px 2px rgba(0,0,0,0.04)",
    "0 2px 8px rgba(0,0,0,0.06)",
    "0 4px 16px rgba(0,0,0,0.08)",
    "0 8px 24px rgba(0,0,0,0.1)",
    "0 12px 32px rgba(0,0,0,0.1)",
    "0 16px 40px rgba(0,0,0,0.12)",
    "0 20px 48px rgba(0,0,0,0.12)",
    "0 24px 56px rgba(0,0,0,0.14)",
    "0 28px 64px rgba(0,0,0,0.14)",
    "0 32px 72px rgba(0,0,0,0.16)",
    "0 36px 80px rgba(0,0,0,0.16)",
    "0 40px 88px rgba(0,0,0,0.18)",
    "0 44px 96px rgba(0,0,0,0.18)",
    "0 48px 104px rgba(0,0,0,0.2)",
    "0 52px 112px rgba(0,0,0,0.2)",
    "0 56px 120px rgba(0,0,0,0.22)",
    "0 60px 128px rgba(0,0,0,0.22)",
    "0 64px 136px rgba(0,0,0,0.24)",
    "0 68px 144px rgba(0,0,0,0.24)",
    "0 72px 152px rgba(0,0,0,0.26)",
    "0 76px 160px rgba(0,0,0,0.26)",
    "0 80px 168px rgba(0,0,0,0.28)",
    "0 84px 176px rgba(0,0,0,0.28)",
    "0 88px 184px rgba(0,0,0,0.3)"
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          transition: "all 0.2s ease"
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          transition: "box-shadow 0.2s ease"
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12
        }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: "none",
          backgroundColor: sidebarBg
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "0 1px 3px rgba(0,0,0,0.06)"
        }
      }
    }
  }
});

export const layout = {
  sidebarWidth: 260,
  contentBg,
  sidebarBg
};
